import React, { useState } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StatePageContainer } from "../../components/ui-elements/pageUITransition";

import Header from "../../layout/header";
import { BackArrowIcon } from "../../components/ui-elements/svg-icons";
import { RepsOne } from "../../components/reps/reps-1";
import { RepsTwo } from "../../components/reps/reps-2";
import { RepresentativeApplyProps } from "../../interface/api";
import useResponsive from "../../hooks/useResponsive";

const Representatative: React.FC = () => {
  const navigate = useNavigate();
  const isMedium = useResponsive("down", "md", "xl");
  const [resp_data, setResp_data] = useState<RepresentativeApplyProps>({
    position_id: "",
    constituency_id: "0",
    district_id: "0",
    state_id: "0",
    local_government_id: "0",
    party_id: "0",
    social_handles: [""],
    sworn_in_date: "",
    proof_of_office: null,
  });
  const [page_number, setPage_number] = useState<number>(1);

  const handle_next = () => {
    setPage_number((prev) => prev + 1);
  };
  const handle_prev = () => {
    if (page_number === 1) {
      return;
    }
    setPage_number((prev) => prev - 1);
  };

  const handle_back = () => {
    if (page_number === 1) {
      navigate(-1);
    } else {
      handle_prev();
    }
  };

  return (
    <>
      <Header>
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <Button onClick={handle_back}>
            {" "}
            <BackArrowIcon />
          </Button>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            Representative profile setup
          </Typography>
        </Stack>
      </Header>
      <Box sx={{ maxWidth: isMedium ? "94%" : 605, mx: "auto", py: "80px" }}>
        <>
          {/* <AnimatePresence mode="wait" initial={false}> */}
          {page_number === 1 && (
            <StatePageContainer id="page1">
              <RepsOne
                next={handle_next}
                resp_data={resp_data}
                setResp_data={setResp_data}
              />
            </StatePageContainer>
          )}
          {page_number === 2 && (
            <StatePageContainer id="page2">
              <RepsTwo
                resp_data={resp_data}
                setResp_data={setResp_data}
                next={() => {}}
              />
            </StatePageContainer>
          )}
          {/* </AnimatePresence> */}
        </>
      </Box>
    </>
  );
};

export default Representatative;
